export default __webpack_public_path__ + "static/media/Ivy 9781408355107.1dbf9ca9.jpg";